import { render, staticRenderFns } from "./PlaceholderInput.vue?vue&type=template&id=5000f416"
import script from "./PlaceholderInput.vue?vue&type=script&lang=js"
export * from "./PlaceholderInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports